/**
 * V2 Card / Panel — surfaces from design_reference (`.card` / `.panel`).
 * `Card` carries the inset top highlight (`--hi-top`) + `--sh-sm`;
 * `Panel` is the flatter variant without the inset highlight.
 */

import { forwardRef } from 'react';
import type { HTMLAttributes } from 'react';
import { cn } from '../../../lib/utils';

/** Card / Panel props (native div attributes). */
export type CardProps = HTMLAttributes<HTMLDivElement>;

/** V2 card surface with inset top highlight. */
export const Card = forwardRef<HTMLDivElement, CardProps>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'bg-[var(--bg-2)] border border-[var(--bd-subtle)] rounded-[var(--r-lg)]',
      'shadow-[inset_0_1px_0_var(--hi-top),var(--sh-sm)]',
      className,
    )}
    {...props}
  />
));
Card.displayName = 'Card';

/** V2 panel surface (no inset highlight). */
export const Panel = forwardRef<HTMLDivElement, CardProps>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'bg-[var(--bg-2)] border border-[var(--bd-subtle)] rounded-[var(--r-lg)] shadow-[var(--sh-sm)]',
      className,
    )}
    {...props}
  />
));
Panel.displayName = 'Panel';
